import React from "react";
import { Link } from "react-router-dom";
import { Image } from "semantic-ui-react";

export default function dopMenu({ isStickyInclusive, isOpenInclusive }) {
  return (
    <div className={`${isStickyInclusive && isOpenInclusive ? "second-block-inclusive" : ""} second-block-nav`}>
      <div className="second-block-nav-logo">
        <Link to="/">
          <Image
            src="images/dg_logo.svg"
            alt="dg_logo"
            className="image-logo-first"
          />
        </Link>
      </div>
      <div className="second-block-nav-links">
        <ul>
          <li>
            <a href="https://sgroshi.com.ua/ua/reverse-form/">
              Зворотній зв'язок
            </a>
          </li>
          <li>
            <a href="https://sgroshi.com.ua/ua/reverse-form/">
              Написати скаргу
            </a>
          </li>
          <li>
            <a href="https://sgroshi.com.ua/ua/oplatyty-kredyt/">Оплатити</a>
          </li>
          <li>
            <a href="https://sgroshi.com.ua/ua/contacts/">Відділення</a>
          </li>
        </ul>
      </div>
      <div className="second-block-nav-contact">
        <a className="phone-number" href="tel:+380735601050">
          +38 073 560 10 50
        </a>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// src/dopMenu.js